<div class="page-content">
    <div class="mainArea">
      <div class="card">
        <div class="tabs">
          <button mat-icon-button (click)="selectTab('dashboard')" [class.active]="selectedTab === 'dashboard'">
            <div class="item">
              <div class="icon-bg card-header-1">
                <i class="fa fa-home"></i>
              </div>
              <div class="centered">Home</div>
            </div>
          </button>
          <!-- <button mat-icon-button (click)="selectTab('my-apps')" [class.active]="selectedTab === 'my-apps'">
            <div class="item">
              <div class="icon-bg card-header-2">
                <i class="fa fa-reorder"></i>
              </div>
              <div class="centered">My Apps</div>
            </div>
          </button>
          <button mat-icon-button (click)="selectTab('other-tab')" [class.active]="selectedTab === 'other-tab'">
            <div class="item">
              <div class="icon-bg card-header-3">
                <i class="fa fa-file"></i>
              </div>
              <div class="centered">Sample App</div>
            </div>
          </button> -->
        </div>
      
        <!-- Content area -->
        <div class="content">
          
          <!-- Dashboard content -->
          <div class="dashboard1" *ngIf="selectedTab == 'dashboard'">
            <div class="card1" style="background: linear-gradient(to bottom, #ff7e5f, #feb47b);">
              <div class="card-content">
                <div class="top-half card-header-3"></div>
                <div class="bottom-half dd1-border"></div>
                <div class="circle dd1-border">
                  <i class="fa fa-book dd"></i>
                </div>
                <div class="description">
                  <h3 class="dd" style="font-weight: bold;">Data Dictionary</h3>
                  <p>Create and manage your data dictionaries.</p>
                  <button class="btn card-header-3" (click)="goToDD()"> Explore Data Dictionary
                    <!-- <a href="http://localhost:5000/" target="_blank">
                     
                    </a> -->
                  </button>
                </div>
              </div>
            </div>
          
            <div class="card1" style="background: linear-gradient(to bottom, #54a0ff, #007bff);">
              <div class="card-content">
                <div class="top-half card-header-1"></div>
                <div class="bottom-half app-border"></div>
                <div class="circle app-border">
                  <i class="fa fa-list app"></i>
                </div>
                <div class="description">
                  <h3 class="app" style="font-weight: bold;">App Maker</h3>
                  <p>Create new applications tailored to your needs</p>
                  <button class="btn card-header-1" (click)="goToAppMaker()">Explore App Maker</button>
                </div>
              </div>
            </div>
          
            <div class="card1" style="background: linear-gradient(to bottom, #00d68f, #37d48e);">
              <div class="card-content">
                <div class="top-half card-header-2"></div>
                <div class="bottom-half admin-border"></div>
                <div class="circle admin-border">
                  <i class="fas fa-user-shield admin"></i>
                </div>
                <div class="description">
                  <h3 class="admin" style="font-weight: bold;">Administration</h3>
                  <p>Add parties, manage roles, and grant access.</p>
                 
                  <button class="btn card-header-2">Explore Administration</button>
                </div>
              </div>
            </div>
          </div>
          
      
          <!-- My Apps content -->
          <div class="my-apps" *ngIf="selectedTab === 'my-apps'">
            <!-- My Apps content goes here -->
          </div>
      
          <!-- Other Tab content -->
          <div class="dashboard1" *ngIf="selectedTab === 'other-tab'">
            <!-- Other Tab content goes here -->
            <div class="card1" style="background: linear-gradient(to bottom, #00d68f, #37d48e);">
              <div class="card-content">
                <div class="top-half card-header-2"></div>
                <div class="bottom-half admin-border"></div>
                <div class="circle admin-border">
                  <i class="fas fa-grip-horizontal admin"></i>
                </div>
                <div class="description">
                  <h3 class="admin" style="font-weight: bold;">Sample App</h3>
                  <p>This is Sample App</p>
                 
                  <button class="btn card-header-2">Go To Sample App</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



